import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,{staticClass:"d-flex align-center justify-center",staticStyle:{"height":"100vh"}},[_c(VCol,[_c('div',{staticClass:"d-flex"},[_c('h1',[_vm._v(_vm._s(_vm.$t('journalNotFound')))]),_c(VIcon,{staticClass:"ml-3",attrs:{"large":"","color":"#111111"}},[_vm._v("fa-frown-open")])],1),_c('p',{staticClass:"mt-2 mb-10"},[_vm._v(_vm._s(_vm.$t('sharedJournalNotFound')))]),_c(VBtn,{on:{"click":_vm.goToDashboard}},[_vm._v(_vm._s(_vm.$t('goToDashboard')))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }